<template>
    <div class="lw-course-contents-arrow right-arrow full-height lw-hide-sp" v-show="display"  @click="emitAction('action-triggered',template)">
        <span class="learnworlds-icon large fas fa-angle-right pos-abs center"></span>
    </div>
</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "SliderForthArrow",
        mixins: [ComponentTemplatesMixin],
        props: {
            display: {
                type: Boolean
            },
            template: {
                type: String
            }
        },
    }
</script>

